baseApp.service('AccountAuthService', ['GeneralUtilsService', function(GeneralUtilsService,$rootScope) {

    let AccountAuthService = {};

    AccountAuthService.getAccountAuthSettings = function(accountId, callback) {
        fetchData(accountId, function(data) {
            callback(data);
        });
    };

    var setData = function(accountId, account, callback) {
        store.save({
            path: '/edit',
            data: account,
            dataObj: 'json',
            queryParams: {
                accountId: accountId,
                save: true,
                fields: "['accountAuthSettings','externalSystemConfiguration']",
            },
            success: function (data) {
                callback(data);
            },
        });
    }

    AccountAuthService.saveAuthSettings = function(accountId, account, callback) {
        setData(accountId, account, function(data) {
            callback(data);
        });
    }

    function fetchData(accountId, callback) {
        store.fetch({
            path: '/accountAuthSettings',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback({
                    accountAuthSettings: data.model
                });
            }
        })
    };

    AccountAuthService.getServerUrl = function(callback) {
        store.fetch({
            path: '/getServerUrl',
            success: function (data) {
                callback(data);
            }
        })
    }

    AccountAuthService.getAzureTenant = function(accountId, callback) {
        store.fetch({
            path: '/getAzureTenant',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback(data);
            }
        })
    }

    //gets ExternalSystemConfiguration of the account
    AccountAuthService.getExternalSystemConfiguration = function (accountId, callback) {
        store.fetch({
            path: '/getExternalSystems',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback(data);
            }
        })
    };

    return AccountAuthService;
}]);
